import React from "react";
import { Button, styled } from "@mui/material";
import clsx from "clsx";

const ButtonStyled = styled(Button)({
  borderRadius: "3rem",
  whiteSpace: "nowrap",
  "&.square": {
    borderRadius: "0.25rem",
  },
  "&.btn-unstyled": {
    background: "none",
    color: "inherit",
    border: "none",
    padding: 0,
    font: "inherit",
    cursor: "pointer",
    outline: "inherit",
    "&:disabled": {
      cursor: "default",
      opacity: 0.5,
    },
  },
});

const VARIANTS_DICT = {
  filled: "contained",
  outlined: "outlined",
  text: "text",
};

/**
 * ButtonNewUnstyled component
 * @param {object} props - Props for the button
 * @param {React.ReactNode} props.children - Button content
 * @param {"filled" | "outlined" | "text" | "unstyled"} props.variant - Button variant
 * @param {"primary" | "secondary" | "error" | "success" | "warning" | "info" | "inherit"} props.color - Button color
 * @param {"round" | "square"} [props.corners="round"] - Button corner style
 * @param {boolean} [props.isLoading] - Loading state
 * @param {boolean} [props.isDisabled] - Disabled state
 * @param {boolean} [props.isFullwidth] - Fullwidth button
 * @param {"button" | "submit" | "reset"} props.type - Button type
 * @param {React.ReactNode} [props.startIcon] - Icon at the start of the button
 * @param {React.ReactNode} [props.endIcon] - Icon at the end of the button
 * @param {"small" | "medium" | "large"} props.size - Button size
 * @param {function} [props.onClick] - Click handler
 * @param {string} [props.className] - Additional class names
 */
const ButtonNewUnstyled = ({
  children,
  variant,
  color,
  corners = "round",
  isLoading,
  isDisabled,
  isFullwidth,
  type,
  startIcon,
  endIcon,
  size,
  onClick,
  className,
}) => {
  return (
    <ButtonStyled
      variant={VARIANTS_DICT[variant]}
      color={color}
      fullWidth={isFullwidth}
      loading={isLoading}
      disabled={isDisabled}
      type={type}
      startIcon={startIcon}
      size={size}
      endIcon={endIcon}
      className={clsx(className, variant, corners, {
        "btn-unstyled": variant === "unstyled",
      })}
      onClick={onClick}
    >
      {children}
    </ButtonStyled>
  );
};

const ButtonNew = styled(ButtonNewUnstyled)({});

export default ButtonNew;
